export const STATE = {
  GET: 0,
  SET: 1,
} as const

export const TIPO_TARJETA_BANCARIA = {
  CREDITO: 1,
  DEBITO: 2,
  PREPAGO: 3,
} as const

export const TIPO_TARJETA_AFTERBANKS = {
  Crédito: TIPO_TARJETA_BANCARIA.CREDITO,
  Débito: TIPO_TARJETA_BANCARIA.DEBITO,
  Prepago: TIPO_TARJETA_BANCARIA.PREPAGO,
} as const
export type TipoTarjetaAfterbanksType = keyof typeof TIPO_TARJETA_AFTERBANKS

export const PRIME_REACT_MODAL_DEFAULT_PROPS = {
  dialog: {
    root: {
      className: "tw-p-6 tw-pb-4 tw-rounded-md tw-bg-white tw-shadow-lg",
    },
    mask: {
      className: "tw-bg-black/50",
    },
    header: {
      className: "tw-flex tw-justify-between tw-items-center",
    },
    headerTitle: {
      className: "tw-text-2xl tw-font-bold tw-text-erp-primary",
    },
    headerIcons: {
      className: "tw-flex tw-justify-end",
    },
    content: {
      className: " tw-flex tw-flex-col tw-gap-4 tw-overflow-auto tw-h-full",
    },
    transition: (options: $TSMigrationFixMe) => {
      return {
        ...options,
        timeout: 0,
      }
    },
  },
  calendar: {
    root: {
      className: "",
    },
    panel: {
      className:
        "tw-grid tw-gap-4 tw-bg-white tw-rounded-md tw-shadow-md tw-w-1/4 tw-p-4",
    },
    group: {
      className: "tw-flex tw-flex-col tw-gap-4",
    },
    title: {
      className: "tw-flex tw-flex-row tw-gap-2",
    },
    monthTitle: {
      className: "tw-capitalize",
    },
    monthPicker: {
      className: "tw-grid tw-grid-cols-3 tw-gap-2 tw-capitalize tw-text-center",
    },
    yearPicker: {
      className:
        "tw-grid tw-grid-flow-row-dense tw-grid-cols-2 tw-grid-rows-5 tw-gap-2 tw-text-center",
    },
    day: {
      className:
        "data-[p-other-month=true]:tw-cursor-default tw-cursor-pointer data-[p-other-month=true]:hover:tw-bg-white hover:tw-bg-gray-50 tw-rounded-md tw-p-1",
    },
    dayLabel: {
      className: "data-[p-disabled=true]:tw-text-gray-400",
    },
    month: {
      className: "tw-cursor-pointer hover:tw-bg-gray-50 tw-rounded-md tw-p-1",
    },
    year: {
      className: "tw-cursor-pointer hover:tw-bg-gray-50 tw-rounded-md tw-p-1",
    },
    table: {
      className: "tw-w-full tw-text-center",
    },
    header: {
      className: "tw-flex tw-justify-between tw-items-center",
    },
  },
  dropdown: {
    root: {
      className:
        "tw-flex tw-justify-between tw-items-center tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md tw-cursor-pointer tw-bg-white",
    },
    panel: {
      className:
        "tw-flex tw-p-2 tw-border tw-border-gray-300 tw-bg-white tw-rounded-md tw-shadow-md tw-max-w-full",
    },
    wrapper: {
      className: "tw-w-full",
    },
    list: {
      className: "tw-flex tw-flex-col tw-cursor-pointer",
    },
    item: {
      className:
        "tw-outline-none tw-p-2 tw-rounded-md hover:tw-bg-gray-50 tw-text-nowrap tw-overflow-hidden tw-overflow-ellipsis tw-max-w-full",
    },
    input: {
      className: "tw-text-nowrap tw-overflow-hidden tw-overflow-ellipsis",
    },
  },
  inputtext: {
    root: {
      className: "tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded-md",
    },
  },
} as const
